;
(function(){
  // A WeakSet to track which <img> elements we've already processed
  const healed = new WeakSet();

  /**
   * Checks all possible URLs on an <img> (src, srcset, data-src, data-srcset) via HTTP HEAD.
   * If any URL returns 404 or errors, attempts to fetch and replace with a valid product image.
   */
  function healImg(img) {
    // Avoid re-processing the same image
    if (healed.has(img)) return;
    healed.add(img);

    // Collect all URLs to test from src, srcset, and lazy-load attributes
    const urls = [
      img.src,
      ...(img.srcset || '').split(',').map(s => s.trim().split(/\s+/)[0]),
      img.dataset.src,
      ...(img.dataset.srcset || '').split(',').map(s => s.trim().split(/\s+/)[0])
    ];

    // Normalize URLs (add protocol if needed), dedupe, and filter for Shopify CDN
    const testUrls = Array.from(new Set(
      urls
        .filter(Boolean)
        .map(u => u.startsWith('//') ? 'https:' + u : u)
        .filter(u => u.includes('cdn.shopify.com'))
    ));

    // HEAD-check each URL; on 404 or error, trigger fallback
    testUrls.forEach(url => {
      fetch(url, { method: 'HEAD' })
        .then(res => {
          if (res.status === 404) {
            fallback(img);
          }
        })
        .catch(() => {
          fallback(img);
        });
    });
  }

  /**
   * Fetches /products/{handle}.js for the given img's product and replaces
   * src, srcset, and lazy-load attributes with the first valid image.
   */
  function fallback(img) {
    // Find the nearest product link to derive the handle
    const link = img.closest('a[href*="/products/"]');
    if (!link) return;

    // Extract handle and build JSON endpoint URL
    const handle = link.getAttribute('href')
      .split('/products/')[1]
      .split('/')[0];
    const jsonUrl = `/products/${handle}.js`;

    // Fetch the product JSON
    fetch(jsonUrl)
      .then(r => {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(product => {
        // Use the first image in the product.images array
        if (product.images && product.images.length) {
          let newSrc = product.images[0];
          if (newSrc.startsWith('//')) newSrc = 'https:' + newSrc;

          // Update src, srcset, and any data-src attributes
          img.src = newSrc;
          img.srcset = newSrc;
          if (img.dataset.src)    img.dataset.src    = newSrc;
          if (img.dataset.srcset) img.dataset.srcset = newSrc;
        }
      })
      .catch(() => {
        // Fail silently if JSON fetch fails
      });
  }

  /**
   * Scans all <img> elements on the page and applies healImg to each.
   */
  function scanAll() {
    document.querySelectorAll('img').forEach(healImg);
  }

  // Run initial scan on full page load and on Shopify PJAX page changes
  window.addEventListener('load', scanAll);
  document.addEventListener('page:load', scanAll);

  /**
   * Observe the document for new <img> nodes or attribute changes
   * (e.g., lazy-loading, infinite scroll), and heal those images too.
   */
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') healImg(node);
          else if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach(healImg);
          }
        });
      } else if (
        m.type === 'attributes' &&
        ['src','srcset','data-src','data-srcset'].includes(m.attributeName) &&
        m.target.tagName === 'IMG'
      ) {
        healImg(m.target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src','srcset','data-src','data-srcset']
  });
})();
